import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import {Route, Switch} from 'react-router';

import Book from './Book';
import Plan from './Plan';
import NotFound from './NotFound';
import Online from './widgets/Online';

export default class extends Component {
	render() {
		return (
			<Fragment>
				<div className="container">
					<Switch>
						<Route exact path='/book' component={Book} />
						<Route path='/book/:date' component={Book} />
						<Route exact path='/plan' component={Plan} />
						<Route component={NotFound} />
					</Switch>
				</div>
				<Link to="/" className="back" title="На главную" />
				<Online />
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Page.js